import React from 'react';
import { MessageCircle, Zap, Clock, Bot } from 'lucide-react';
import useMobile from '../hooks/useMobile';

const ChatbotSection = ({ onStartChat }) => {
  const isMobile = useMobile();

  return (
    <div style={{
      background: 'linear-gradient(135deg, #7c3aed, #6d28d9)',
      borderRadius: '24px',
      padding: isMobile ? '40px 20px' : '60px',
      marginBottom: '60px',
      color: 'white',
      textAlign: 'center'
    }}>
      <Bot size={64} style={{ marginBottom: '20px' }} />
      <h2 style={{ 
        fontSize: isMobile ? '2rem' : '2.5rem', 
        marginBottom: '20px' 
      }}>
        Instant Help with AI Assistant
      </h2>
      <p style={{ 
        fontSize: '1.2rem', 
        marginBottom: '40px',
        opacity: 0.95,
        maxWidth: '600px',
        margin: '0 auto 40px'
      }}>
        Get immediate answers to your questions about setup, features, pricing, and more with our intelligent chatbot
      </p>
      <button 
        onClick={onStartChat}
        style={{
          backgroundColor: 'white',
          color: '#7c3aed',
          border: 'none',
          padding: '16px 40px',
          borderRadius: '8px',
          fontSize: '1.2rem',
          fontWeight: 'bold',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '10px'
        }}
      >
        <MessageCircle size={24} />
        Start Chat Now
      </button>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '40px',
        marginTop: '40px',
        flexWrap: 'wrap'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Zap size={20} />
          <span>Instant Responses</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Clock size={20} />
          <span>Available 24/7</span>
        </div>
      </div>
    </div>
  );
};

export default ChatbotSection;